import axios from 'axios';

const axiosInstance = axios.create({
  withCredentials: true,
  headers: { 'Accept-Language': 'ru' },
});

export { axiosInstance };
